class JD1FeaturedFour extends HTMLElement {
  connectedCallback() {
    if (this.dataset.jd1FeaturedReady === 'true') {
      this.mountAll();
      return;
    }
    this.dataset.jd1FeaturedReady = 'true';
    this.mountAll();
    this.observer = new MutationObserver(() => this.scheduleMount());
    this.observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.mountFrame) cancelAnimationFrame(this.mountFrame);
  }

  scheduleMount() {
    if (this.mountFrame) cancelAnimationFrame(this.mountFrame);
    this.mountFrame = requestAnimationFrame(() => {
      this.mountFrame = null;
      this.mountAll();
    });
  }

  mountAll() {
    this.querySelectorAll('[data-jd1-featured-slot]').forEach((slot) => {
      const template = slot.querySelector('template[data-jd1-custom-gallery]');
      const gallery = slot.querySelector('.card-gallery');
      if (!template || !gallery || gallery.dataset.jd1CustomGalleryMounted === 'true') return;
      const customGallery = template.content.cloneNode(true);
      const firstVisualNode = gallery.querySelector(':scope > a[ref="cardGalleryLink"], :scope > product-title, :scope > slideshow-component');
      gallery.insertBefore(customGallery, firstVisualNode || gallery.firstChild);
      gallery.dataset.jd1CustomGalleryMounted = 'true';
    });
  }
}

if (!customElements.get('jd1-featured-four')) {
  customElements.define('jd1-featured-four', JD1FeaturedFour);
}